import { isValidAlphaNumericButNotNumeric } from '@utils/characters';
import { TypeOfPropsFor } from '@utils/types';

import { FormattedInputBuilder } from './common';

const blocks = {
  FIRST_BLOCK: {
    mask: '000',
  },
  SECOND_BLOCK: {
    mask: '000',
  },
  THIRD_BLOCK: {
    mask: '00',
  },
  FOURTH_BLOCK: {
    mask: '00',
  },
};

export const PhoneNumber = FormattedInputBuilder({
  mask: '(FIRST_BLOCK) SECOND_BLOCK THIRD_BLOCK FOURTH_BLOCK',
  blocks,
  name: 'phoneNumber',
  shouldPreventChar: isValidAlphaNumericButNotNumeric,
});
export default PhoneNumber;

export type PhonNumberProps = TypeOfPropsFor<typeof PhoneNumber>;
